// initial state
import * as base from './base.js'
const baseName = '/admin/system/facility'
const deliveryName = '/admin/system/delivery'//出库记录
// const tagsRecordName = '/admin/api/deviceTagsRecord'
const deviceClasseName = '/admin/system/facilityType'
const  devicedamageName = '/admin/system/damage'
const sceneName = '/admin/system/scene'
const devicestockName = '/admin/system/stock'
const devicescrapName = '/admin/system/scrap'


const devicedelivery = deliveryName + '/list'
// const swapDevice = baseName + '/swapDevice'
// const updateDevice = baseName + '/updateDevice'
// const controlDevice = baseName + '/controlDevice'
// const refreshDevice = baseName + '/refreshDevice'
// const deviceLatlngs = baseName + '/latlngs'
// const deviceQuery = baseName + '/queryDevice'
// const deviceTest = baseName + '/test'
const deciceClass = deviceClasseName + '/list'
const scene = sceneName + '/list'
const devicedamage = devicedamageName + '/list'
const devicestock = devicestockName + '/list'
const devicescrap = devicescrapName + '/list'
const decicestate = baseName + '/state'




const obj = base.setBaseUrl('device', baseName)
const obj1 = base.setBaseUrl('devicedelivery', deliveryName)
const obj2 = base.setBaseUrl('devicedamage', devicedamageName)
const obj3 = base.setBaseUrl('deciceClass', deviceClasseName)
const obj4 = base.setBaseUrl('scene', sceneName)
const obj5 = base.setBaseUrl('devicestock', devicestockName)
const obj6 = base.setBaseUrl('devicescrap', devicescrapName)
const obj7 = base.setBaseUrl('decicestate', baseName)




// const obj2 = base.setBaseUrl('deviceTagsRecord', tagsRecordName)
const a = Object.assign(obj, obj1,obj3,obj2,obj4,obj5,obj6,obj7, {deciceClass, devicedelivery,devicedamage,scene,devicestock,devicescrap,decicestate})
export default a
